import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import style from './style.module.scss';

const TableCell = ({
  className,
  children,
  number,
  bold,
  light,
  right,
  fit,
  onlyHover,
  ...props
}) => {
  const tdClassName = cx(
    style.cell,
    {
      [style.number]: number,
      [style.bold]: bold,
      [style.light]: light,
      [style.cellRight]: right,
      [style.cellFit]: fit,
      [style.onlyHover]: onlyHover,
    },
    className
  );

  return (
    <td {...props} className={tdClassName}>
      {children}
    </td>
  );
};

TableCell.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  number: PropTypes.bool,
  bold: PropTypes.bool,
  light: PropTypes.bool,
  right: PropTypes.bool,
  fit: PropTypes.bool,
  onlyHover: PropTypes.bool,
};

export default TableCell;
